import { CommonModule } from '@angular/common';
import { Component, computed } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { FormsModule } from '@angular/forms';
import { MatTooltip } from '@angular/material/tooltip';
import { Router } from '@angular/router';
import { NzAlertModule } from 'ng-zorro-antd/alert';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzPopconfirmModule } from 'ng-zorro-antd/popconfirm';
import { NzPopoverModule } from 'ng-zorro-antd/popover';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzUploadModule } from 'ng-zorro-antd/upload';
import { take } from 'rxjs';
import { TextImageModalComponent } from '../../basic/modal/text-image-modal/text-image-modal.component';
import { ToLocaleFormat } from '../../basic/pipes/to-locale-format.pipe';
import { TruncatePipe } from '../../basic/pipes/truncate.pipe';
import { CreditHistory } from '../../core/credit/credit';
import { CreditHistoryService } from '../../core/credit/credit-history.service';
import { BoardIconComponent } from '../../domain/board/board-icon/board-icon.component';
import { InterviewSidebarComponent } from '../home/interview-sidebar/interview-sidebar.component';
import { ReferralService } from './../../core/referral/referral.service';
import { UserClerkService } from './../../core/user/user-clerk.service';

@Component({
  selector: 'app-history',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,

    NzIconModule,
    NzInputModule,
    NzButtonModule,
    NzTableModule,
    NzPopoverModule,
    NzUploadModule,
    NzModalModule,
    NzPopconfirmModule,
    NzAlertModule,

    TruncatePipe,
    ToLocaleFormat,

    MatTooltip,

    InterviewSidebarComponent,
    BoardIconComponent,
    TextImageModalComponent,
  ],
  templateUrl: './history.component.html',
  styleUrl: './history.component.scss',
})
export class HistoryComponent {
  constructor(
    private router: Router,
    private userClerkService: UserClerkService,
    private referralService: ReferralService,
    private msg: NzMessageService,
    private creditHistoryService: CreditHistoryService
  ) {}

  isReferVisible = false;

  user = toSignal(this.userClerkService.getUser$());

  credits = computed(() => {
    return (this.user()?.publicMetadata['credits'] as number) ?? 0;
  });

  inviteEmail?: string;

  onInviteClick() {
    this.referralService
      .refer$(this.inviteEmail!)
      .pipe(take(1))
      .subscribe((data) => {
        this.isReferVisible = false;
        if (data.isSuccess === false && data.errCode === 'HAS_REFERRAL') {
          this.msg.error('You have already referred this friend!', { nzDuration: 10000 });
        } else if (data.isSuccess === false && data.errCode === 'HAS_USER') {
          this.msg.error('The user has been successfully registered.', { nzDuration: 10000 });
        } else {
          this.msg.success('Referred successfully!');
        }
      });
  }

  onReferToWinPointsClick() {
    this.isReferVisible = true;
  }

  onBuyMorePointsClick() {
    const url = this.router.serializeUrl(this.router.createUrlTree(['/pricing']));
    window.open(url, '_blank');
  }

  getTitle(creditHistory: CreditHistory) {
    return this.creditHistoryService.getTitle(creditHistory);
  }

  creditHistoryList = toSignal(this.creditHistoryService.creditHistoryList$(), { initialValue: [] });
}
